export default "__VITE_PUBLIC_ASSET__d8df9f76__"